import { render, staticRenderFns } from "./VManageForm.vue?vue&type=template&id=38b469e2"
import script from "./VManageForm.vue?vue&type=script&lang=js"
export * from "./VManageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports